import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { FlowsLayout } from "./components/flows/FlowsLayout";
import { AdminLayout } from "./components/layout/AdminLayout";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import Analytics from "./pages/Analytics";
import Brand from "./pages/Brand";
import BrandCategoryPages from "./pages/BrandCategoryPages";
import Brands from "./pages/Brands";
import CachePage from "./pages/Cache";
import Categories from "./pages/Categories";
import ColdCall from "./pages/ColdCall";
import ColdCalls from "./pages/ColdCalls";
import Competition from "./pages/Competition";
import CssStatus from "./pages/CssStatus";
import Customers from "./pages/Customers";
import Dashboard from "./pages/Dashboard";
import Diagnostics from "./pages/Diagnostics";
import FlowEditor from "./pages/flows/FlowEditor";
import FlowRun from "./pages/flows/FlowRun";
import FlowsApprovals from "./pages/flows/FlowsApprovals";
import FlowsCalendar from "./pages/flows/FlowsCalendar";
import FlowsComparisons from "./pages/flows/FlowsComparisons";
import FlowsList from "./pages/flows/FlowsList";
import FlowsRuns from "./pages/flows/FlowsRuns";
import FlowsSchedule from "./pages/flows/FlowsSchedule";
import FlowsSeoQueue from "./pages/flows/FlowsSeoQueue";
import FlowsSettings from "./pages/flows/FlowsSettings";
import FlowsTemplates from "./pages/flows/FlowsTemplates";
import IssueReports from "./pages/IssueReports";
import Login from "./pages/Login";
import Merchant from "./pages/Merchant";
import Merchants from "./pages/Merchants";
import Metrics from "./pages/Metrics";
import Planner from "./pages/Planner";
import Product from "./pages/Product";
import ProductLines from "./pages/ProductLines";
import Products from "./pages/Products";
import Recommendations from "./pages/Recommendations";
import RevenueChannels from "./pages/RevenueChannels";
import "./App.css";

const App = () => {
	return (
		<BrowserRouter>
			<AuthProvider>
				<Routes>
					<Route path="/login" element={<Login />} />
					<Route
						element={
							<ProtectedRoute>
								<AdminLayout />
							</ProtectedRoute>
						}
					>
						<Route path="/dashboard" element={<Dashboard />} />
						<Route path="/analytics" element={<Analytics />} />
						<Route path="/metrics" element={<Metrics />} />
						<Route path="/revenue" element={<RevenueChannels />} />
						<Route path="/recommendations" element={<Recommendations />} />

						{/*
						 * The editor and the run inspector are full-width work surfaces:
						 * they sit outside FlowsLayout so the sub-nav does not compete
						 * with a canvas for vertical space.
						 */}
						<Route path="/flows/new" element={<FlowEditor />} />
						<Route path="/flows/runs/:runId" element={<FlowRun />} />
						<Route path="/flows" element={<FlowsLayout />}>
							<Route index element={<FlowsList />} />
							<Route path="templates" element={<FlowsTemplates />} />
							<Route path="runs" element={<FlowsRuns />} />
							<Route path="comparisons" element={<FlowsComparisons />} />
							<Route path="seo" element={<FlowsSeoQueue />} />
							<Route path="approvals" element={<FlowsApprovals />} />
							<Route path="schedule" element={<FlowsSchedule />} />
							<Route path="calendar" element={<FlowsCalendar />} />
							<Route path="settings" element={<FlowsSettings />} />
						</Route>
						<Route path="/flows/:id" element={<FlowEditor />} />
						<Route path="/css-status" element={<CssStatus />} />
						<Route path="/competition" element={<Competition />} />
						<Route path="/issue-reports" element={<IssueReports />} />
						<Route path="/diagnostics" element={<Diagnostics />} />
						<Route path="/cache" element={<CachePage />} />
						<Route path="/planner" element={<Planner />} />
						<Route path="/categories" element={<Categories />} />
						<Route path="/brands" element={<Brands />} />
						<Route path="/brands/:slug" element={<Brand />} />
						<Route path="/products" element={<Products />} />
						<Route path="/product-lines" element={<ProductLines />} />
						<Route path="/brand-pages" element={<BrandCategoryPages />} />
						<Route path="/products/:id" element={<Product />} />
						<Route path="/merchants" element={<Merchants />} />
						<Route path="/merchants/:id" element={<Merchant />} />
						<Route path="/customers" element={<Customers />} />
						<Route path="/cold-calls" element={<ColdCalls />} />
						<Route path="/cold-calls/:id" element={<ColdCall />} />
					</Route>
					<Route path="*" element={<Navigate to="/dashboard" replace />} />
				</Routes>
			</AuthProvider>
		</BrowserRouter>
	);
};

export default App;
